<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4 border-bottom">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar usuario - {{ data.type }}{{ data.id }}</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <router-link :to="{ name: 'UserDetail', params: { role: role, id: id } }" class="btn btn-h btn-dark px-3">
                                    <span class="pe-2">
                                        <i class="bi bi-card-list"></i>
                                    </span>
                                    <span>Mostrar detalles</span>
                                </router-link>
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-surface-secondary">
                    <v-tabs v-model="tab" @change="CHANGE()">
                        <v-tab :key="'account'"><i class="fa-solid fa-circle-exclamation text-danger" v-if="errors.account_type || errors.company || errors.first_name || errors.last_name || errors.warehouse_id || errors.email || errors.username || errors.gender"></i> General</v-tab>
                        <v-tab :key="'notes'"><i class="fa-solid fa-circle-exclamation text-danger" v-if="errors.phone || errors.deliver_to || errors.address || errors.country_id || errors.province_id || errors.city_id || errors.district_id || errors.branch_office_id"></i> Información de contacto</v-tab>
                        <v-tab :key="'fel'"><i class="fa-solid fa-circle-exclamation text-danger" v-if="errors.fel || errors.identification_type || errors.identification || errors.email_fel || errors.activity_code_fel"></i> Facturación Electrónica</v-tab>
                        <v-tab :key="'security'">Seguridad</v-tab>
                        <v-tab :key="'more'"><i class="fa-solid fa-circle-exclamation text-danger" v-if="errors.discount || errors.pin || errors.price_per_pound || errors.minimum_billable_amount"></i> Más</v-tab>
                    </v-tabs>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="'account'">
                            <account :data="data" :errors="errors" v-if="tab == 0" />
                        </v-tab-item>
                        <v-tab-item :key="'notes'">
                            <contact :data="data" :errors="errors" v-if="tab == 1" />
                        </v-tab-item>
                        <v-tab-item :key="'fel'">
                            <fel :data="data" :errors="errors" v-if="tab == 2" />
                        </v-tab-item>
                        <v-tab-item :key="'security'">
                            <security :data="data" :errors="errors" v-if="tab == 3" />
                        </v-tab-item>
                        <v-tab-item :key="'more'">
                            <more :data="data" :errors="errors" v-if="tab == 4" />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import Account from './forms/Account'
import Contact from './forms/Contact'
import Fel from './forms/Fel'
import More from './forms/More'
import Security from './forms/Security'
export default {
    components: { Account, Contact, Fel, More, Security },
    data() {
        return {
            open: [0],
            data: {},
            errors: {},
            count: 0,
            id: this.$route.params.id,
            role: this.$route.params.role,
            tab: Number(localStorage.getItem('tab_user_update') | 0),
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/users/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UPDATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/users/' + vue.id, method: 'PUT', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ path: '/admin/panel/users/' + vue.role })
                    })
                    .catch((err) => {
                        if(err.response.status === 422){
                            vue.errors = err.response.data
                        }else if(err.response.status === 402 || err.response.status === 404){
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }else{
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        },
        CHANGE: function() {
            let vue = this
            localStorage.setItem('tab_user_update', vue.tab)
        },
    },
}
</script>